var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    [
      !_vm.success && _vm.message
        ? _c(
            "div",
            {
              staticClass:
                "custom-label-tighter mb-6 flex items-center font-medium",
              style: _vm.messageStyle,
            },
            [
              _c("span", {
                staticClass: "flex-grow",
                domProps: { textContent: _vm._s(_vm.message) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.success ? _vm._t("success") : _vm._e(),
      _vm._v(" "),
      !_vm.success
        ? _vm._t("default", null, { isDisabled: _vm.isDisabled })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }